import { createFilledIcon } from "../createIcon";

export const AlertTriangleFilledIcon = createFilledIcon(
  <>
    <path d="M4.746 20.4c-.892 0-1.65-.502-2.065-1.365a2.701 2.701 0 0 1 .135-2.64L10.071 4.72c.45-.725 1.13-1.119 1.93-1.119.797 0 1.479.396 1.928 1.12l7.257 11.675c.501.807.55 1.777.135 2.64-.418.865-1.176 1.365-2.065 1.365H4.746Zm7.272-6.6a1.2 1.2 0 0 1-1.2-1.2V7.8a1.2 1.2 0 1 1 2.4 0v4.8a1.2 1.2 0 0 1-1.2 1.2Zm0 4.2a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4Z" />
  </>,
  "AlertTriangleFilledIcon"
);
